import React, { useState } from 'react'
import './TravelFinished.min.css'


interface Baggage {
  id: number;
  name: string;
  isDone: number;
}


interface Props {
  baggage: Baggage;
  

}


const BaggagesTravelEnd: React.FC<Props> = ({ baggage }) => {

  return (

    <div className='list'>
      <div className='done'>

        {baggage.isDone == 1 ? (
          <span>
            <input type='checkbox' checked={true} readOnly></input>
            <s className='text'> {baggage.name} </s>
          </span>
        ) : (
          <span>
            <input type='checkbox' checked={false} readOnly></input>
            <span className='text'> {baggage.name}</span>
          </span>
        )
        }

      </div>
    </div>
   
  )
}

export default BaggagesTravelEnd